import orderBy from 'lodash/orderBy';
import { CORE_MENTEE_MODULE_STATUSES } from '../data/coreMenteModuleStatuses';

function getOrderedCoreMenteeModules(menteeModules) {
  const coreMenteeModules = orderBy(menteeModules, ['order'], ['asc']).filter(
    (menteeModules) =>
      CORE_MENTEE_MODULE_STATUSES.includes(menteeModules.status)
  );

  const orderedCoreMenteeModules = coreMenteeModules.map((mm) => ({
    mentee_module_id: mm.id,
    order: mm.order,
  }));

  return orderedCoreMenteeModules;
}

export default getOrderedCoreMenteeModules;
